export const REMOVED_ATTACHMENT_VALUE = "";
export const DEFAULT_IMAGE_EXTENSIONS = ["jpeg", "jpg", "png"];
export const CERTIFICATE_EXTENSIONS = [...DEFAULT_IMAGE_EXTENSIONS, "pdf"];

export const getAttachmentAccept = (allowedExtensions) =>
  allowedExtensions.map((extension) => `.${extension.replace(/^\./, "")}`).join(",");

export const isAttachmentExtensionAllowed = (fileName, allowedExtensions) => {
  const extension = fileName?.split(".").pop()?.toLowerCase();
  if (!extension) return false;

  return allowedExtensions.some(
    (allowedExtension) =>
      allowedExtension.replace(/^\./, "").toLowerCase() === extension,
  );
};

/**
 * Applies an attachment state to either FormData or a plain request object.
 *
 * Contract:
 * - object: upload/replace the attachment
 * - null: explicitly delete the saved attachment by sending an empty value
 * - anything else: leave the property out of the request
 */
export const applyAttachmentToPayload = (payload, fieldName, attachment) => {
  const isRemoval = attachment === null;
  const isUpload = typeof attachment === "object" && attachment !== null;

  if (!isRemoval && !isUpload) return false;

  const value = isRemoval ? REMOVED_ATTACHMENT_VALUE : attachment;

  if (typeof payload?.append === "function") {
    payload.append(fieldName, value);
  } else {
    payload[fieldName] = value;
  }

  return true;
};

export const createAttachmentRemovalPayload = (fieldName) => {
  const payload = {};
  applyAttachmentToPayload(payload, fieldName, null);
  return payload;
};
